import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_DAMAGE_DETECTION_REQUEST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_DAMAGE_DETECTION_REQUEST`;
export const INTELLIGENT_PHOTO_CAPTURE_DAMAGE_DETECTION_SUCCESS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_DAMAGE_DETECTION_SUCCESS`;
export const INTELLIGENT_PHOTO_CAPTURE_DAMAGE_DETECTION_FAILURE = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_DAMAGE_DETECTION_FAILURE`;
export const photoCaptureIntelligentDamageDetectionRequestAction = (companyCode, request, instanceReferenceId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_DAMAGE_DETECTION_REQUEST,
    payload: { companyCode, request, instanceReferenceId }
});
export const photoCaptureIntelligentDamageDetectionSuccessAction = (damageDetectionResponse, iterationId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_DAMAGE_DETECTION_SUCCESS,
    payload: {
        damageDetectionResponse,
        iterationId
    }
});
export const photoCaptureIntelligentDamageDetectionFailureAction = (failureMessage, iterationId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_DAMAGE_DETECTION_FAILURE,
    payload: {
        failureMessage,
        iterationId
    }
});
//# sourceMappingURL=photoCaptureIntelligentDamageDetectionAction.js.map